import { Box } from '@mui/material'

const DividerBlock = () => (
  <Box sx={{ width: '100%', height: '1px', backgroundColor: 'var(--app-border-light)', my: '16px' }} />
)

export default DividerBlock
